import {
  configureWebObservability,
  type WebObservability,
  type WebObservabilityOptions,
} from "@infinitaslearning/observability-web";
import type { Config } from "@/lib/config";
import { name } from "../../../package.json";

const getObservabilityOptions = (
  environment: Config["ilEnv"],
  buildVersion: Config["buildVersion"],
): WebObservabilityOptions => {
  const serviceName = name;
  const serviceVersion = buildVersion;

  const options: WebObservabilityOptions = {
    serviceName,
    serviceVersion,
    environment,
  };

  if (environment === "local") {
    options.serverUrl =
      "https://a2ccf4ce09324b819578f6253260eca7.apm.westeurope.azure.elastic-cloud.com:443";
    options.sendCredentials = false;
    options.transactionSampleRate = 1;
    options.serverUrlPrefix = undefined;
  }

  return options;
};

type ObservabilityParams = {
  environment: Config["ilEnv"];
  buildVersion: Config["buildVersion"];
};
export const observability = {
  start: ({ environment, buildVersion }: ObservabilityParams): { apm: WebObservability } => {
    const options = getObservabilityOptions(environment, buildVersion);
    const apm: WebObservability | null = configureWebObservability(options);
    if (!apm) {
      throw new Error("Failed to initialize observability");
    }

    console.debug("Observability initialized with options:", { options });
    return { apm };
  },
};
